export default function SystemCenter({
  onArchiveOldShifts,
  onArchiveOldWorkers,
  onSeedTestWorkers,
}) {
  return (
    <div style={{ display: "grid", gap: 12 }}>
      <div
        style={{
          padding: 16,
          borderRadius: 16,
          background: "#ffffff",
          border: "1px solid #e2e8f0",
        }}
      >
        <div style={{ fontSize: 20, fontWeight: 950 }}>System</div>
        <div style={{ marginTop: 4, color: "#64748b", fontWeight: 700 }}>
          Maintenance, diagnostics, seed data, archive tools, and platform operations.
        </div>
      </div>

      <div
        style={{
          padding: 16,
          borderRadius: 16,
          background: "#ffffff",
          border: "1px solid #e2e8f0",
          display: "flex",
          gap: 10,
          flexWrap: "wrap",
        }}
      >
        <button type="button" onClick={onArchiveOldShifts}>
          Archive Old Shifts
        </button>

        <button type="button" onClick={onArchiveOldWorkers}>
          Archive Old Workers
        </button>

        <button type="button" onClick={onSeedTestWorkers}>
          Seed Test Workers
        </button>
      </div>
    </div>
  );
}